import type { OrderCancellationPolicyActionType } from '@/backend/market'

export class OrderCancellationPolicyHistoryFilterEntity {
  branchId?: number
  policyId?: number
  actionType?: OrderCancellationPolicyActionType
  escalationMatched?: boolean
  fromDate?: Date | string | null
  toDate?: Date | string | null
  page?: number
  limit?: number
}
